class ShowcaseSlider {
  constructor() {
    this.slides = document.querySelectorAll(".slide");
    this.startSlider(5000);
  }

  startSlider = (interval) => {
    const start = () => {
      const current = document.querySelector(".slide--current");
      current.classList.remove("slide--current");
      if (current.nextElementSibling) {
        current.nextElementSibling.classList.add("slide--current");
      } else {
        this.slides[0].classList.add("slide--current");
      }
      setTimeout(() => current.classList.remove("slide--current"));
    };

    setInterval(start, interval);
  };
}

export default ShowcaseSlider;
